import { ref } from "vue";
import { ArticlePreviewDto } from "../model/article";
import { SearchAnalytics } from "@/shared/utils/analytics/analytics-search";
import { httpClient } from "@sazka/utils/http-clients/http-client";

const searchResultList = ref<ArticlePreviewDto[]>([]);
const searchText = ref("");
const areSearchResultsVisible = ref(false);

const hideSearchResults = () => {
    searchResultList.value = [];
};

const fetch = async (searchText: string, topn = 10) => {
    try {
        const response = await httpClient.get<ArticlePreviewDto[]>(
            `/api/help-center/search?searchText=${searchText}&topn=${topn}`
        );
        return response.data;
    } catch (e) {
        return [];
    }
};

const fetchAutocomplete = async (text: string) => {
    return fetch(text);
};

const fetchResults = async (text: string) => {
    searchText.value = text;
    if (!text) {
        searchResultList.value = [];
        areSearchResultsVisible.value = false;
    } else {
        searchResultList.value = await fetch(text, 20);
        areSearchResultsVisible.value = true;
    }
    SearchAnalytics.pushSearchResults("help center", text, searchResultList.value.length);
};

export const useHcSearch = () => ({
    searchText,
    searchResultList,
    areSearchResultsVisible,
    fetchResults,
    fetchAutocomplete,
    hideSearchResults,
});
